import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import Button from "../../common/Button/Button";
import { GetNetsuiteItemsCancelToken } from '../../../services/CourseService';
import {
  GetShortCourseList,
  ListShortCourseFilters,
  deleteShortCourse
} from "../../../services/ProgramService";
import {
  RenderCredits,
  RenderDeliveryMethod,
  RenderLearningMethod,
  RenderProgrammeLevel,
  RenderSchool
} from "../../../utils/CommonGroupingItem";
import { RenderPMCStatus } from "../../../utils/CommonStatusItems";
import { handleTableScroll } from "../../../utils/commonFunction";
import PermissionsGate from "../../../utils/permissionGate";
import DataTableComponent from "../../common/DataTableComponent";
import { TrimText } from "../../common/TrimText";
import "../programsTable.css";

const Program = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [school, setSchool] = useState({arr:[], checkObj:{}});
  const [learning, setLearning] = useState({arr:[], checkObj:{}});
  const [delivery, setDelivery] = useState({arr:[], checkObj:{}});  
  const [credits, setCredits] = useState({arr:[], checkObj:{}});
  const [status, setStatus] = useState({arr:[],checkObj:{}});
  const [level, setLevel] = useState({arr:[],checkObj:{}});
  const [loading, setloading] = useState(true);
  const [updateData, setUpdateData] = useState(Date.now());
  const [filterData, setFilterData] = useState({status : [], school : [], learning:[], delivery:[], credits:[], level:[]})
  const [tableState, setTableState] = useState({
    page: 1,
    perPage: 10,
    sortKey: "name",
    sortOrder: "asc",
  });
  const [totalRows, setTotalRows] = useState(0);
  const [netsuiteList, setNetsuiteList] = useState([]);
  const [dataProcessed, setDataProcessed] = useState([]);
  
  useEffect(() => {
    handleTableScroll()
  }, [loading])
  
  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })
  
  useEffect(() => {
    const storedFilters = JSON.parse(localStorage.getItem("filterstatePMCShortCourses"));
    if (storedFilters) {
      storedFilters?.status && setStatus(storedFilters.status);
      storedFilters?.learning && setLearning(storedFilters.learning);
      storedFilters?.delivery && setDelivery(storedFilters.delivery);
      storedFilters?.credits && setCredits(storedFilters.credits);
      storedFilters?.school && setSchool(storedFilters.school);
      storedFilters?.level && setLevel(storedFilters.level);
    }
  }, []);
  useEffect(() => {
    const filterState = {
      status,
      learning,
      delivery,
      credits,
      school,
      level
    };
    localStorage.setItem("filterstatePMCShortCourses", JSON.stringify(filterState));
  }, [status, learning, delivery, credits, school, level]);
  
  useEffect(() => {
    const cancelTokenSources = [];
    
    const getProgram = async () => {      
      
      cancelTokenSources.forEach(source => {
        source.cancel('New request made');
      });
      
      const source = axios.CancelToken.source();
      cancelTokenSources.push(source);
      
      try {
        const payload = {
          page:tableState.page,
          limit:tableState.perPage,
          key:tableState.sortKey,
          sort:tableState.sortOrder,
          search : search,
          exportStatus:"false",
          viaStatus:status.arr,
          viaLearningMethod:learning.arr,
          viaCourseDelivery:delivery.arr,
          viaCreditesStatus:credits.arr,
          viaSchool:school.arr,
          viaLevel:level.arr
          
        }
        const res = await GetShortCourseList(payload, source.token);
        if (res.status === 200) {
          // console.log(res.data.data)
          setData(res.data.data);
          setTotalRows(res.data.total)
          
        }
        if(netsuiteList.length == 0){
          const data2 = await GetNetsuiteItemsCancelToken(
            'All'
          );
          setNetsuiteList(
            data2 && data2.data && data2.data.data && data2.data.data.items
            ? data2.data.data.items
            : []
          );
        }
        setloading(false); 
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
          setloading(false); 
        }
      };
    }
    setloading(true);
    getProgram();
    
    return () => {
      cancelTokenSources.forEach(source => {
        source.cancel('Component unmounted');
      });
    };
  }, [updateData, tableState, school, status, search, level, delivery, credits, learning]);
  
  useEffect(() => {
    if (netsuiteList.length > 0 && data && data.length > 0) {
      const updatedData = data.map((item) => {
        const matchedNetsuite = netsuiteList.find((i) => {
          return i.id == item.netsuite_product;
        });
        return {
          ...item,
          netsuite_product_name: matchedNetsuite ? matchedNetsuite.displayname : "-",
        };
      });
      setDataProcessed(updatedData);
    } else {
      setDataProcessed([]);
    }
  }, [netsuiteList, data]);
  useEffect(() => {
    const filterSource = axios.CancelToken.source();
    const getFilters = async () =>{
      try {
        const res = await ListShortCourseFilters(filterSource.token);
        if(res?.status==200){
          setFilterData({...res.data, status: res.data?.status, learning:res.data?.learningMethod, delivery:res.data?.courseDelivery, credits:res.data?.creditesStatus, level:res.data?.level, school:res.data?.school  })
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    }
    
    getFilters()
    return () => {
      filterSource.cancel('Component unmounted');      
    };
  }, [updateData])
  
  usePermissionGuardRedirect(['pmcpview']);
  
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortField: "name",
      sortable: true,
      cell: (row) => (        
        <Link
        to={`/program-management-center/programmes/shortCourse/open/${row.Id}`}
        title={row.name}
        className="as-text-blue curser feature-name"
        >
        <span title={row.name} className="textLimit100">
        {row.name}
        </span>
        </Link>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortField: "status",
      sortable: true,
      cell: (row) =>
        row?.status != null ? RenderPMCStatus(row?.status).html : "-",
    },    
    {
      name: "Code",
      selector: "Code",
      sortField: "Code",
      sortable: true,
      cell: (row, index) => (
        <div className="ticket-id">
        <span title={row.Code} className="overflow-ellipsis2">
        {row.Code ? TrimText(row.Code, 10) : "-"}
        </span>
        </div>
      ),
    },
    {
      name: "Learning Methods",
      selector: "learning Methods",
      sortField: "learning Methods",
      sortable: true,
      cell: (row) => (
        <p className="learningMethodText">
        {row && row.learning_method.map((learning, index)=>learning?.learning_method ? RenderLearningMethod(learning.learning_method,index).html : "-") }
        </p>
      ),
    },
    {
      name: "Delivery",
      selector: "delivery",  
      sortField: "delivery",
      sortable: true,
      cell: (row) => 
        row && row?.course_delivery.length > 0 ? row?.course_delivery.map((delivery, index)=> delivery?.delivery_method && RenderDeliveryMethod(delivery?.delivery_method, index).html) : "-",// cell: (row) => row && row.course_delivery.map((delivery, index)=>delivery?.delivery_method ? RenderDeliveryMethod(delivery?.delivery_method,index).html : "-")
    },
    {
      name: "Credits",
      selector: "Credits",
      sortField: "Credits",
      sortable: true,
      cell: (row) =>
        row?.credit_status != null ? RenderCredits(row?.credit_status).html : "-",
    },
    {
      name: "Level",
      selector: "level",
      sortField: "level",
      sortable: true,
      cell: (row) => row && row?.level ? RenderProgrammeLevel(row?.level).html : "-",
    },
    {
      name: "Netsuite Product",
      selector: "netsuite_product",
      sortable: true,
      cell: (row) => (<><span className="textLimit50" title={row.netsuite_product_name}>{row.netsuite_product_name ? row.netsuite_product_name : "-" }</span></>),
    },
    {
      name: "School",
      selector: "School",
      sortField: "School",
      sortable: true,
      cell: (row) => row?.School ? <span className="feature-name"><span className="textLimit100">{RenderSchool(row?.School).html}</span></span> : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
        <div className="as-buttons">
        <PermissionsGate
        scopes={["pmcpedit"]}
        RenderError={() => (
          <button
          className="btn btn-primary rounded-circle"
          title="Open"
          disabled
          >
          <i className="fal fa-folder-open"></i>
          </button>
        )}
        >
        <Link
        to={`/program-management-center/programmes/shortCourse/open/${row.Id}`}
        className="btn btn-primary rounded-circle"
        title="Open"
        >
        <i className="fal fa-folder-open"></i>
        </Link>
        </PermissionsGate>
        
        <div className="dropdown btn-dropdown-item">
        <button
        className="btn btn-primary rounded-circle dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        title="More"
        >
        <i className="fal fa-ellipsis-h-alt"></i>
        </button>
        <div
        className="dropdown-menu"
        aria-labelledby="dropdownMenuButton"
        >
        <PermissionsGate
        scopes={["pmcpadd"]}
        RenderError={() => (
          <button
          className="btn btn-primary rounded-circle"
          title="Duplicate"
          disabled
          >
          <i className="fal fa-copy"></i>
          </button>
        )}
        >
        <Link
        to={`/program-management-center/programmes/shortCourse/duplicate/${row.Id}`}
        className="btn btn-primary rounded-circle"
        title="Duplicate"
        >
        <i className="fal fa-copy"></i>
        </Link>
        </PermissionsGate>
        {/* <PermissionsGate
          scopes={["pmcpview"]}
          RenderError={() => (
            <button
          className="btn btn-primary rounded-circle"
          title="Programme View"
          disabled
          >
          <i className="fal fa-eye"></i>
          </button>
          )}
          >
          <Link
          to={`/program-management-center/exportProgramme/${row.Id}`}
          target="_blank"
          className="btn btn-primary rounded-circle"
          title="View Programme"
          >
          <i className="fal fa-eye"></i>
          </Link>
          </PermissionsGate> */}
          
          <PermissionsGate
          scopes={["pmcpdelete"]}
          RenderError={() => (
            <button
            className="btn btn-danger rounded-circle"
            title="Delete"
            disabled
            >
            <i className="fal fa-trash-alt"></i>
            </button>
          )}
          >
          <button
          title="Delete"
          className="btn btn-danger rounded-circle"
          onClick={() => handleDelete(row.Id)}
          >
          <i className="fal fa-trash-alt"></i>
          </button>
          </PermissionsGate>
          </div>
          </div>
          </div>
          </div>
        ),
      },
    ], []);
    
    const handleDelete = (id) => {    
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteShortCourse({ id: id })
          .then((res) => {
            Swal.fire("Deleted!", "Course has been deleted.", "success");
            setUpdateData(Date.now());
          })
          .catch((error) => console.log(error));
        }
      });
    };
    
    const exportData = (fileType, fileName) => {
      let exportData = data;
      
      const header = ["Name", "Status", "Learning Method", "Delivery Method", "Credits", "Code", "Level","School"];
      
      Swal.fire({
        title: "File downloading",
        onOpen: function () {
          Swal.showLoading();
        },
      });
      
      const payload = {
        page:tableState.page,
        limit:tableState.perPage,
        key:tableState.sortKey,
        sort:tableState.sortOrder,
        exportStatus:"true",
        viaStatus:status.arr,
        viaLearningMethod:learning.arr,
        viaCourseDelivery:delivery.arr,
        viaCreditesStatus:credits.arr,
        viaSchool:school.arr,
        viaLevel:level.arr
      }
      
      GetShortCourseList(payload).then((res)=>{
        exportData = res.data;
        exportData = exportData?.map((row) => ({
          ...row,
          Name: row?.name ? row?.name : "-",
          Status: row.status ? RenderPMCStatus(row.status).text : "-",
          "Learning Method" : row?.learning_method ? row.learning_method.map(item => RenderLearningMethod(item?.learning_method).text).join(", ") : "-",      
          "Delivery Method":  row?.course_delivery?.length ? row.course_delivery.map(item => RenderDeliveryMethod(item?.delivery_method).text).join(", ") : "-",
          Credits: row?.credit_status != null ? RenderCredits(row?.credit_status).text : "-",
          Code: row.Code ? row.Code : "-",
          Level: row && row?.level ? RenderProgrammeLevel(row?.level).text : "-",
          School: row.School ? RenderSchool(row.School).text : "-",
        }));
        
        if (fileType === "csv") {
          const csvString = Papa.unparse({ fields: header, exportData });
          const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });
          
          const blobURL = window.URL.createObjectURL(blob);
          
          // Create new tag for download file
          const anchor = document.createElement("a");
          anchor.download = fileName;
          anchor.href = blobURL;
          anchor.dataset.downloadurl = [
            "text/csv",
            anchor.download,
            anchor.href,
          ].join(":");
          anchor.click();
          
          // Remove URL.createObjectURL. The browser should not save the reference to the file.
          setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            URL.revokeObjectURL(blobURL);
          }, 1000);
          Swal.close();
        } else if (fileType === "xlsx") {
          const compatibleData = exportData.map((row) => {
            const obj = {};
            header.forEach((col, index) => {
              obj[col] = row[col];
            });
            return obj;
          });
          
          let wb = XLSX.utils.book_new();
          let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
            header,
          });
          XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
          XLSX.writeFile(wb, `${fileName}.xlsx`);
          Swal.close();
          // Returning false as downloading of file is already taken care of
          return false;
        }
        if (fileType === "pdf") {
          const compatibleData = exportData.map((row) => {
            return [
              row["Name"],
              row["Status"],
              row["Learning Method"],
              row["Delivery Method"],
              row["Credits"],
              row["Code"],
              row["Level"],
              row["School"],
            ];
          });
          const doc = new JsPDF();
          doc.autoTable({
            head: [header],
            body: compatibleData,
            styles: {
              minCellHeight: 10,
              minCellWidth: 5,
              halign: "left",
              // valign: "center",
              fontSize: 8,
            },
          });
          doc.save(`${fileName}.pdf`);
          Swal.close();
          return false;
        }
      }).catch((err)=>{
        console.log(err)
      })    
    };
    
    return (
      <div className="pmc-programmes-table">
      <DataTableComponent
      data={dataProcessed}
      columns={columns}
      loading={loading}
      search={search}
      setSearch={setSearch}
      state={tableState}
      setState={setTableState}
      totalRows={totalRows}
      exportFunction={exportData}
      exportFileName={"shortCourse_List"}    
      filters={[
        {
          filterName: "School",
          optionArr: filterData.school,
          state: school,
          setState: setSchool,
          renderLabelFunction : RenderSchool
        }, 
        {
          filterName: "Learning Methods",
          optionArr: filterData.learning,
          state: learning,
          setState: setLearning,
          renderLabelFunction: RenderLearningMethod,
        },
        {
          filterName: "Delivery",
          optionArr: filterData.delivery,
          state: delivery,
          setState: setDelivery,
          renderLabelFunction: RenderDeliveryMethod,
        },
        {
          filterName: "Credits",
          optionArr: filterData.credits,
          state: credits,
          setState: setCredits,
          renderLabelFunction: RenderCredits,
        },
        {
          filterName: "Status",
          optionArr: filterData.status,
          state: status,
          setState: setStatus,
          renderLabelFunction: RenderPMCStatus,
        },
        {
          filterName: "Level",
          optionArr: filterData.level,
          state: level,
          setState: setLevel,
          renderLabelFunction: RenderProgrammeLevel,
        },         
      ]}                
      tableButton={[
        <PermissionsGate
          scopes={["pmcpadd"]}
          key="create-short-course"
          RenderError={() => (
            <Button
              variant="primary"
              iconLeft={<i className="fal fa-plus" />}
              title="Create New"
              disabled
            >
              Create New
            </Button>
          )}
        >
          <Link to="/program-management-center/programmes/shortCourse/add">
            <Button
              variant="primary"
              iconLeft={<i className="fal fa-plus" />}
              title="Create New"
            >
              Create New
            </Button>
          </Link>
        </PermissionsGate>
      ]}
      />
      </div>
    );
  };
  
  export default Program;
  